import { render, staticRenderFns } from "./PreviewQlRichText.vue?vue&type=template&id=17765602&scoped=true"
import script from "./PreviewQlRichText.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewQlRichText.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17765602",
  null
  
)

export default component.exports